export default __webpack_public_path__ + "static/media/Lizzie 9781408312971.e30b43d9.jpg";